"use strict";
import angular from "angular";
import "./scripts/pixels.ctrls";
import "./scripts/pixels.services";

import pixelManagerHtmlUrl from "./views/pixel_manager.html";
import pixelCreateHtmlUrl from "./views/create_pixel.html";

angular.module("pixelsManager", ["pixels.ctrls", "pixels.services"]).config([
    "$stateProvider",
    function ($stateProvider) {
        $stateProvider
            .state("pixelManager", {
                parent: "layout",
                url: "/items/pixelManager",
                templateUrl: pixelManagerHtmlUrl,
                controller: "PixelManagerController"
            })
            .state("createPixel", {
                parent: "layout",
                url: "/items/createPixel",
                templateUrl: pixelCreateHtmlUrl,
                controller: "CreatePixelController"
            })
            .state('editPixel', {
                parent: 'layout',
                url: '/items/editPixel/:pixelId',
                templateUrl: pixelCreateHtmlUrl,
                controller: 'CreatePixelController',
                params: {
                    pixelId: null
                }
            })
    }
]);
